import React from "react";

export default ({
  children,
  onClick = () => {},
  primary,
  secondary,
  textOnly
}) => (
  <button
    className={
      primary ? "primary" : secondary ? "secondary" : textOnly ? "plain" : ""
    }
    onClick={onClick}
  >
    {children}
  </button>
);
